import styled from 'styled-components'

export const Wrapper = styled.section`
  display: flex;
  justify-content: center;
`

export const TextBlock = styled.div`
  background: ${({ bgColor }) => bgColor || `grey`};
  max-width: 1241px;
  border-radius: 14px;
  min-height: 467px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 3rem 3.6rem;
  color: ${({ theme }) => theme.colors.primary};
  @media only screen and (max-width: 840px) {
    width: 100%;
    justify-content: center;
    min-height: auto;
    padding: 3rem 2rem;
  }
`

export const TextWrapper = styled.div`
  > h1 {
    color: #d5e0ff;
    font-size: 40px;
    font-weight: 600;
    padding-bottom: 2rem;

    @media only screen and (max-width: 1200px) {
      font-size: 30px;
    }
    @media only screen and (max-width: 700px) {
      font-size: 20px;
    }
  }
`

export const Paragraph = styled.div`
  > p > span {
    font-style: italic;
    margin: 0 0.8rem;
  }
  display: flex;
  align-items: baseline;
  > p,
  > p > span {
    font-size: 55px;
    color: white;
    font-weight: 500;
    line-height: 1.5;
    @media only screen and (max-width: 1200px) {
      font-size: 45px;
    }
    @media only screen and (max-width: 700px) {
      font-size: 32px;
    }
  }
`
